import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/app/[locale]/error.tsx");
